import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { LanguageProvider } from './context/LanguageContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import Prodotto from './pages/Prodotto';
import Carrello from './pages/Carrello';
import Checkout from './pages/Checkout';
import NexiResult from './pages/NexiResult';
import NexiCancel from './pages/NexiCancel';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CategoriesPage from './pages/CategoriesPage';
import ProductsPage from './pages/ProductsPage';
import OrdiniPage from './pages/OrdiniPage';
import SettingsPage from './pages/SettingsPage';
import TermsPage from './pages/TermsPage';

import './App.css';

function App() {
  // Basename per produzione (shop è in /shop)
  const basename = process.env.NODE_ENV === 'production' ? '/shop' : '';
  
  return (
    <Router basename={basename}>
      <LanguageProvider>
        <CartProvider>
          <ScrollToTop />
          <div className="App">
          <Routes>
            {/* Pagine con layout completo (Header + Footer) */}
            <Route path="/" element={
              <>
                <Header />
                <main className="main-content">
                  <Home />
                </main>
                <Footer />
              </>
            } />
            <Route path="/prodotto/:id" element={
              <>
                <Header />
                <main className="main-content">
                  <Prodotto />
                </main>
                <Footer />
              </>
            } />
            <Route path="/carrello" element={
              <>
                <Header />
                <main className="main-content">
                  <Carrello />
                </main>
                <Footer />
              </>
            } />
            <Route path="/checkout" element={
              <>
                <Header />
                <main className="main-content">
                  <Checkout />
                </main>
                <Footer />
              </>
            } />
            <Route path="/checkout/nexi-result" element={
              <>
                <Header />
                <main className="main-content">
                  <NexiResult />
                </main>
                <Footer />
              </>
            } />
            <Route path="/checkout/nexi-cancel" element={
              <>
                <Header />
                <main className="main-content">
                  <NexiCancel />
                </main>
                <Footer />
              </>
            } />
            <Route path="/condizioni-di-acquisto" element={
              <>
                <Header />
                <main className="main-content">
                  <TermsPage />
                </main>
                <Footer />
              </>
            } />
            
            {/* Pagine admin senza Header/Footer */}
            <Route path="/amministrazione" element={<AdminLogin />} />
            <Route path="/amministrazione/dashboard" element={<AdminDashboard />} />
            <Route path="/amministrazione/categorie" element={<CategoriesPage />} />
            <Route path="/amministrazione/prodotti" element={<ProductsPage />} />
            <Route path="/amministrazione/ordini" element={<OrdiniPage />} />
            <Route path="/amministrazione/impostazioni" element={<SettingsPage />} />
          </Routes>
        </div>
      </CartProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
